// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form[data-v-6d2d479e]{\n  display: grid;\n  gap: 1rem; /* 16px */\n}\n.button-submit[data-v-6d2d479e] {\n  margin-top: 10px;\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
